import config from '../config';

export function redirectToLogin(): void {
  const dest = encodeURIComponent(window.location.href);
  window.location.assign(`${config.gonfalon.host}/private/login?dest=${dest}`);
}

export function signOut(): void {
  const dest = encodeURIComponent(window.location.href);
  window.location.assign(`${config.gonfalon.host}/private/logout?dest=${dest}`);
}
